if (!customElements.get('elsvin-about-carousel')) {
  customElements.define('elsvin-about-carousel', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const initialize = () => {
        this.frame = requestAnimationFrame(() => this.initialize());
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true, signal: this.events.signal });
      } else {
        initialize();
      }
    }
    initialize() {
      if (!this.isConnected) return;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      const options = { signal: this.events.signal };
      this.index = Math.min(this.index || 0, this.slides.length - 1);
      this.paused = this.dataset.autoplay === 'false';
      this.editorPaused = false;
      this.keyboardFocused = false;
      this.pauseButton = this.querySelector('[data-pause]');
      this.status = this.querySelector('[data-status]');
      this.querySelector('.elsvin-carousel__controls').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
      this.pauseButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.keyboardFocused = this.paused;
        this.sync();
      }, options);
      this.addEventListener('focusin', event => {
        this.keyboardFocused = event.target.matches(':focus-visible');
        this.sync();
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) {
          this.keyboardFocused = false;
          this.sync();
        }
      }, options);
      this.addEventListener('pointerdown', () => {
        this.keyboardFocused = false;
        this.sync();
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) {
          this.editorPaused = true;
          this.show(index, true);
        }
      }, options);
      this.addEventListener('shopify:block:deselect', () => {
        this.editorPaused = false;
        this.sync();
      }, options);
      this.closest('.shopify-section')?.addEventListener('shopify:section:deselect', () => {
        this.editorPaused = false;
        this.sync();
      }, options);
      this.show(this.index, false);
    }
    show(index, manual) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.status.setAttribute('aria-live', manual ? 'polite' : 'off');
      this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
      if (!this.paused && !this.keyboardFocused && !this.editorPaused && !document.hidden && this.isConnected) {
        const interval = Math.max(3000, Number(this.dataset.interval) || 5000);
        this.timer = setTimeout(() => this.show(this.index + 1, false), interval);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      cancelAnimationFrame(this.frame);
      this.events?.abort();
    }
  });
}

